export const UPDATE_CURRENT_TEAM_ID = `team/UPDATE_CURRENT_TEAM_ID`;
export const GET_MEMBERS = 'team/MEMBERS';
export const GET_FEATURES = 'team/FEATURES';



// WEBPACK FOOTER //
// ./src/state/reducers/team/types.js